'use strict';
module.exports = {
	dashed: '8, 8',
	dotted: '2, 4',
	solid: ''
};
